<template>
  <div class="batchList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @productChange="productChange"
    ></SiruiSearch>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :min-width="120"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token }"
    ></sirui-upload>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/settle';
  import tableMixins from '@/common/mixins/table.js';
  import siruiUpload from '@/components/SiruiUpload';
  import XEUtils from 'xe-utils';
  export default {
    name: 'batchList',
    mixins: [tableMixins],
    components: {
      siruiUpload,
    },
    data() {
      return {
        action: API.IMPORT_ORDERSETTLE,
        exportAction: API.EXPORT_ORDERSETTLE,
        query: {
          settleNo: null, // 结算批次编号
          settleDesc: null, // 结算批次描述
          supplierNo: null, // 供应链主体
          orderNo: null, // 业务订单
          settleType: null, // 结算类型
          settleStatus: null, // 结算批次状态
          productNo: null, // 商品编码
          productDesc: null, // 商品描述
          settleCreateDateStart: null, // 创建日期起
          settleCreateDateEnd: null, // 创建日期止
        },
        columnListDefault: [
          { type: 'checkbox', width: '50', fixed: 'left' }, // 复选框
          { field: 'settleNo', title: 'batchList.column.settleNo' }, // 结算批次编号
          { field: 'settleDesc', title: 'batchList.column.settleDesc' }, // 结算批次描述
          { field: 'settleType', title: 'batchList.column.settleType', dictType: 'settle_type' }, // 结算类型
          { field: 'shippingName', title: 'batchList.column.shippingName' }, // 装运名称
          { field: 'deliveryQuantity', title: 'batchList.column.deliveryQuantity' }, // 发货数量
          { field: 'supplierName', title: 'batchList.column.supplierNo' }, // 供应链主体
          { field: 'productNo', title: 'batchList.column.productNo' }, // 商品编码
          { field: 'productDesc', title: 'batchList.column.productDesc' }, // 商品描述
          { field: 'settleDepartmentName', title: 'batchList.column.settleDepartmentName' }, // 部门
          { field: 'settleCreatePersonName', title: 'batchList.column.settleCreatePersonName' }, // 创建人
          { field: 'settleCreateDate', title: 'batchList.column.settleCreateDate' }, // 创建日期
          {
            field: 'settleStatus',
            title: 'batchList.column.settleStatus',
            dictType: 'settle_status',
          }, // 结算批次状态
          { field: 'mark', title: 'batchList.column.mark' }, // 备注
        ],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            // 结算批次编号
            prop: 'settleNo',
            name: this.$t('batchList.column.settleNo'),
            type: 'input',
          },
          {
            // 结算批次描述
            prop: 'settleDesc',
            name: this.$t('batchList.column.settleDesc'),
            type: 'input',
          },
          {
            // 供应链主体
            prop: 'supplierNo',
            name: this.$t('batchList.column.supplierNo'),
            type: 'searchTableSpec',
            searchType: 'supplychain',
            isMultiple: true,
          },
          {
            // 业务订单
            prop: 'orderNo',
            name: this.$t('batchList.column.orderNo'),
            type: 'searchTableSpec',
            searchType: 'businessOrder',
            isMultiple: true,
          },
          {
            // 结算类型
            prop: 'settleType',
            name: this.$t('batchList.column.settleType'),
            type: 'dict',
            dictType: 'settle_type',
          },
          {
            // 结算批次状态
            prop: 'settleStatus',
            name: this.$t('batchList.column.settleStatus'),
            type: 'dict',
            dictType: 'settle_status',
          },
          {
            // 商品编码
            prop: 'productNo',
            name: this.$t('batchList.column.productNo'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            currentValue: this.query.productNo,
            changeMethod: 'productChange',
          },
          {
            // 商品描述
            prop: 'productDesc',
            name: this.$t('batchList.column.productDesc'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            currentValue: this.query.productDesc,
            changeMethod: 'productChange',
          },
          {
            // 创建日期起
            prop: 'settleCreateDateStart',
            name: this.$t('batchList.search.settleCreateDateStart'),
            type: 'startDaterangePicker',
          },
          {
            // 创建日期止
            prop: 'settleCreateDateEnd',
            name: this.$t('batchList.search.settleCreateDateEnd'),
            type: 'endDaterangePicker',
          },
        ];
      },
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      getData() {
        //获取数据
        const params = this.setSearchParams();
        this.load = true;
        this.$axios.post(API.LIST_ORDER_SETTLE_BY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageSize, pageNum };
        params.supplierNo = params.supplierNo ? params.supplierNo[0].supplierCode : null;
        params.orderNo = params.orderNo ? params.orderNo[0].orderNo : null;
        return params;
      },
      productChange(val) {
        this.searchTableChange(val.val, [
          { val: 'productNo', getVal: 'productDetailCode' },
          { val: 'productDesc', getVal: 'detailProductDisplayName' },
        ]);
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.query[item.val] = val[0][item.getVal];
            } else {
              this.query[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.query[item.val] = null;
          });
        }
      },
      chooseClick(type) {
        if (type == 'add') {
          this.toPath('batchAdd', {});
        } else if (type == 'edit') {
          this.handleEdit();
        } else if (type == 'del') {
          this.handleDel();
        } else if (type == 'export') {
          this.handleExport();
        } else if (type == 'import') {
          this.handleImport();
        }
      },
      dblclickEvent(value) {
        // 列表双击
        this.toPath('batchDetail', { id: value.row.id });
      },
      async handleEdit() {
        // 修改
        if (this.multipleSelection.length != 1) {
          return this.tips('onlyOneSelectData', 'error');
        }
        let item = this.multipleSelection[0];
        let res = await this.$axios.post(API.CHK_ORDERSETTLESLIPSTATUS, {
          settleNo: item.settleNo,
        });
        if (res) {
          if (res.data.code == 0) {
            this.toPath('batchEdit', { id: item.id });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
      },
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${this.baseUrl}${this.exportAction}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${this.exportAction}?${params}&access_token=${this.token.access_token}`;
        }
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      handleDel() {
        // 删除
        if (this.multipleSelection.length == 0) return this.tips('noSelected', 'error');
        let ids = this.multipleSelection.map((i) => i.id);
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios.post(API.DELETE_ORDERSETTLE, ids).then((res) => {
              if (res.data.code == 0) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`batchList.message.${info}`),
          type: type,
        });
      },
      toPath(name, query) {
        // 跳转路径
        let path = {
          path: `/settle/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
